import { createClient } from '@supabase/supabase-js';

const Url = 'https://hynmctzoemxttjsmvjyz.supabase.co';
const Key = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh5bm1jdHpvZW14dHRqc212anl6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkwNDAwNDYsImV4cCI6MjA1NDYxNjA0Nn0.E5zLmTJrawuggO3Tc6-ld45RjC0dczMXAG4kpbnLTnE';

export const supabase = createClient(Url, Key);